import pageData from './pageData';
import requestData from './requestData';

export const reducers = {
    pageData,
    requestData
};
